<template>
	<div class="sign_wrap">
		<el-button v-if="!isAgreement" class="start_btn" type="primary" @click="toLogin">开始入驻</el-button>
		<h3 class="f666 tc">{{ title }}</h3>
		<div class="intro">
			<p class="fwb">一.入驻流程</p>
			<p>入驻申请→初审→编辑线上合同→复审→缴纳保证金→提交纸质材料→开通后台账号；</p>
			<p>注：每一个环节的状态，系统都会邮件或短信告知商家，商家也可以登入注册账号进行查询。</p>
		</div>
		<div class="up_info mt20">
			<p class="fwb">二.入驻须知</p>
			<p>(1) 商家入驻的品类如果涉及到多个部门，系统仅允许“先”入驻一个部门负责的品类，待入驻成功后方可入驻其他品类；</p>
			<p>(2) 商家申请主营品牌有两种方式：第一种，选择大V店品牌库已有的品牌；第二种，手动输入大V店品牌库还未录入的品牌信息。商家需优先采用第一种方式，如果品牌库搜索不到，再采用第二种方式；</p>
			<p>(3) 非图书品类的每一个品牌均需选择要入驻的品类，未选择入驻的品类，后期创建商品信息则无法创建成功；</p>
			<p>(4) 入驻申请或提交初审前，如有任何疑问，可邮件询问“bd@davdian.com”；提交初审后，会有对接采销与您联系，相关问题可直接询问对接采销；</p>
			<p>(5) 商家入驻多个品类，只需缴纳一份保证金，保证金取多个品类中最高的。</p>
		</div>
		<div class="up_info mt20">
			<p class="fwb">三.入驻常见问题</p>
			<ul class="q_and_a">
				<li v-for="(val,index) in questions"><a class="questions" :class="{'actives': num === index}" @click="skan_q(index)">{{val}}</a></li>
			</ul>
			<div class="tabs">

				<div class="tab" v-if="num === 0">
					<p class="mb10"><strong>1. 入驻流程介绍。</strong></p>
					<img width="660" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/1.png" alt="">
				</div>

				<div class="tab" v-if="num == 1">
					<p><strong>2. 在供应商信息页面，为什么申请主营品类时候总是提示只能申请一个部门的品类？</strong></p>
					<p align="left" class="text_intro">为了方便系统快速将申请入驻的供应商分配给对应的采销审核，商家入驻的品类如果涉及到多个采销部门运营的品类，系统会限制供应商先申请一个部门运营的品类。待入驻成功后，供应商可以再申请入驻其他品类。
					</p>
				</div>

				<div class="tab" v-if="num == 2">
					<p><strong>3. 有些品类需要上传“品类经营特许资质”，这个是什么？</strong></p>
					<el-table :data="table1" border style="width: 100%">
						<el-table-column prop="name" label="文件名称" min-width="180" align="center"></el-table-column>
						<el-table-column prop="cata" label="资质要求及涉及品类" width="180" align="center"></el-table-column>
					</el-table>
					<p><strong>所有证件格式要求：证件复印件，然后加盖公司红章，再扫描上传。图片格式支持JPG/GIF/PNG，每张图片大小不得超过1M。</strong></p>
				</div>

				<div class="tab" v-if="num == 3">
					<p><strong>4. 基本资质证件说明。</strong></p>
					<el-table :data="table2" border style="width: 100%">
						<el-table-column prop="name" label="文件名称" min-width="180" align="center"></el-table-column>
						<el-table-column prop="cata" label="资质要求及涉及品类" min-width="180" align="center"></el-table-column>
					</el-table>
					<p><strong>证件复印件，然后加盖公司红章，再扫描上传。”图片格式支持JPG/GIF/PNG，每张图片大小不得超过1M。</strong></p>
				</div>

				<div class="tab" v-if="num == 4">
					<p><strong>5. 如何申请主营的品牌？</strong></p>
					<p align="left">申请主营品牌分为两种方式：（1）申请大V店品牌库中已有的品牌；（2）审核添加大V店品牌库未录入的品牌。</p>
					<p align="left"><strong>（1）申请大V店品牌库已有的品牌</strong></p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-1.png" alt="">
					<p align="left">在右上角搜索框输入品牌关键字，点击搜索，查看大V店品牌库是否已经录入品牌。</p>
					<p align="left">如果搜索到需要的品牌，点击勾选：</p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-2.png" alt="">
					<p align="left">点击【确定】，选中品牌。确定品牌之后，为该品牌绑定之前申请主营的品类：</p>
					<img width="86%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-3.png" alt="">
					<p align="left" class="main_word">重点：非图书品类的供应商，按照页面提示填写信息，上传页面要求的品牌相关的证件。</p>
					<p align="left" class="main_word">图书品类不需要绑定品类和上传证件</p>
					<p align="left"><strong>（2）申请添加新品牌</strong></p>
					<p align="left">没有搜索到申请的品牌，可以添加您要主营的品牌：</p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-4.png" alt="">
					<p align="left">输入品牌的“中文名称”“英文名称”“品牌介绍”“重点商品链接（淘宝、天猫、京东等平台的商品链接）”。</p>
					<p align="left">然后和第（1）中类型一样，绑定主营的品类和填写相应品牌信息、上传相应证件</p>
					<p align="left" class="main_word">可以申请多个品牌。</p>
				</div>

				<div class="tab" v-if="num == 5">
					<p><strong>6. 为什么在点击【提交审核】时，页面提示“所有品类信息至少要绑定一个品牌”？</strong></p>
					<p align="left" class="text_intro">供应商申请入驻的品类，每一个品类至少绑定一个申请主营的品牌，否则不能提交审核。
						比如您申请入驻2个品类：个护化妆—面部护肤—面膜，个护化妆—面部护肤—眼部护理。
						申请主营品牌为“丽得姿”，在品牌页面您只给品牌绑定了“个护化妆—面部护肤—面膜”，如下所示：
					</p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/6-1.png" alt="">
					<p align="left" class="mt10 mb10"><strong>这个时候提交审核时候，系统就会提示：</strong></p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/6-2.png" alt="">
					<p align="left" class="mt10"><strong>因为申请的另一个品类“个护化妆—面部护肤—眼部护理”没有绑定任何品牌，所以不能提交。</strong></p>
					<p align="left" class="mb10"><strong>在品牌详情页绑定品类和品牌的关系：</strong></p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/6-3.png" alt="">
				</div>

				<div class="tab" v-if="num == 6">
					<p><strong>7. 提交审核之后，接下来供应商应该做什么事情？</strong></p>
					<p align="left" class="text_intro">提交审核之后，进入初审。等待采销审核。
						初审通过之后，大V店会短信、邮件通知您初审通过。等待采销编辑和合同协议，您再确认合同。
						初审驳回，大V店会短信、邮件通知您驳回及驳回原因。您可以登录查看进展和驳回原因、修改申请信息，再次提交审核。
					</p>
				</div>

				<div class="tab" v-if="num == 7">
					<p><strong>8. 供应商在确认合同过程中，应该做什么？</strong></p>
					<p class="text_intro" align="left">采销编辑完成合同，推送给供应商审核。供应商会收到邮件和短信提示。登录大V服务平台，进入【合同协议】页面，可以查看合同信息：</p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-1.png" alt="">
					<p align="left" class="mb20 text_intro"><strong>点击【查看详情】，查看合同详细内容：</strong></p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-2.png" alt="">
					<p align="left" class="mb10 text_intro"><strong>点击合同协议页面的【线上合同信息】后面的【编辑】按钮，供应商填写“乙方”需要填写的合同信息：</strong></p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-3.png" alt="">
					<img width="84%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-4.png" alt="">
					<p align="left" class="main_word text_intro"><strong>所有“粉色”下划线处，都是需要供应商编辑的信息。请仔细阅读合同内容并填写信息。</strong></p>
				</div>

				<div class="tab" v-if="num == 8">
					<p><strong>9. 供应商对合同内容有异议，应该怎么做？</strong></p>
					<p align="left" class="text_intro">对合同内容有疑问，不同意合同。可以驳回合同。点击【合同协议】列表的【不同意合同】，输入原因，系统会反馈到大V店采销：</p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/9.png" alt="">
				</div>


				<div class="tab" v-if="num == 9">
					<p><strong>10. 供应商对合同没有疑问，应该怎么做？</strong></p>
					<p align="left" class="text_intro">填写完成线上合同内容，并且同意合同内容。点击合同协议列表页面的【同意合同】，进入复审。复审主要是大V店的财务、法务人员审核所有合同、资质信息。
					</p>
				</div>

				<div class="tab" v-if="num == 10">
					<p><strong>11. 同意合同之后，供应商还需要做什么？</strong></p>
					<p align="left" class="text_intro">供应商同意合同之后，进入入驻复审流程。等待品类总监、法务、财务复审。</p>
					<p align="left">（1）如果供应商资质信息不正确，复审驳回会直接驳回给供应商修改。
						系统会邮件、短信通知供应商。供应商登录后查看驳回原因，修改可修改的信息，重新提交等待再次复审。</p>
					<p align="left">（2）如果法务审核合同协议不过关，系统会驳回给采销，由采销修改合同。然后推送给供应商确认修改的合同。
						供应商同意修改后的合同内容，再次进入复审。
					</p>
				</div>

				<div class="tab" v-if="num == 11">
					<p><strong>12. 复审通过之后，供应商审核时候可以使用大V服务平台添加商品？</strong></p>
					<p align="left" class="text_intro">复审通过之后，等到供应商的保证金（有些品类不需要交保证金）到账、纸质合同邮寄到大V店。系统会开通供应商注册账号的供应商使用权限。
						系统会短信、邮件通知供应商。
						重新登录后，即可使用大V服务平台相关功能，添加商品、管理订单等。</p>
				</div>

				<div class="tab" v-if="num == 12">
					<p><strong>13. 供应商如何查看入驻进展？</strong></p>
					<p align="left" class="text_intro">登录大V服务平台，可以随时在页面查看入驻进展：</p>
					<img width="80%" src="http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/13.png" alt="">
				</div>

				<div class="tab" v-if="num == 13">
					<p><strong>14. 如何联系大V店工作人员？</strong></p>
					<p align="left" class="text_intro">入驻申请或提交初审前，如有任何疑问，可邮件询问“bd@davdian.com”或”cm@davdian.com”；提交初审后，会有对接采销与您联系，相关问题可直接询问对接采销。</p>
				</div>
			</div>
		</div>

		<!-- 提示弹框 -->
		<el-dialog title="未登录" :visible.sync="tipDialog" size="tiny">
		  <span>入驻前请先登录</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="tipDialog = false">取 消</el-button>
		    <a href="/suppliers/index">
		    	<el-button type="primary" @click="dialogVisible = false">去登录</el-button>
		    </a>
		  </span>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			return {
				num:'',
				isactive: false,
				title: "大V店入驻事项",
				checked: false,					// 是否同意协议
				isAgreement: true,      // 是否入驻协议
				tipDialog: false,				//  提示登录弹框

				questions: [
					"1.入驻流程介绍。",
					"2.在供应商信息页面，为什么申请主营品类时候总是提示只能申请一个部门的品类？",
					"3. 有些品类需要上传“品类经营特许资质”，这个是什么？",
					"4. 基本资质证件说明。",
					"5. 如何申请主营的品牌？",
					"6. 为什么在点击【提交审核】时，页面提示“所有品类信息至少要绑定一个品牌”？",
					"7. 提交审核之后，接下来供应商应该做什么事情？",
					"8. 供应商在确认合同过程中，应该做什么？",
					"9. 供应商对合同内容有异议，应该怎么做？",
					"10. 供应商对合同没有疑问，应该怎么做？",
					"11. 同意合同之后，供应商还需要做什么？",
					"12. 复审通过之后，供应商审核时候可以使用大V服务平台添加商品？",
					"13. 供应商如何查看入驻进展？",
					"14. 如何联系大V店工作人员？"
				],

				table1: [
					{name: "食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证", cata: "食品"},
					{name: "食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证、保健食品批准证书以及保健食品生产企业批准证书、进口保健食品批准证书（如为进口保健食品）", cata: "保健食品"},
					{name: "出版物经营许可证", cata: "出版物、音像制品、电子出版物"},
					{name: "医疗器械经营许可证", cata: "第二类医疗器械"},
					{name: "批次化妆品检验报告；特殊用途化妆品卫生批准文件（如为特殊用途化妆品）；生产厂家卫生许可证复印件以及生产厂家生产许可证复印件", cata: "国产化妆品"},
					{name: "进口化妆品卫生许可批件；进口化妆品厂家检验报告；进口检验检疫部门检验报告以及标签审核证书", cata: "进口化妆品"}
				],
				table2: [
					{name: "营业执照副本", cata: "必须具有独立法人资格；如为分支机构，不具有独立法人资格，需提供总公司授权书"},
					{name: "法定代表人身份证", cata: "有效期内，正反面复印"},
					{name: "税务登记证（三证合一后无需提供）", cata: "有效期内"},
					{name: "组织机构代码证（三证合一后无需提供）", cata: "有效期内"},
					{name: "一般纳税人认定证书", cata: "有效期内"},
					{name: "开户银行许可证", cata: "有效期内"},
					{name: "商标注册证", cata: "有效期内"},
					{name: "品牌授权销售代理协议或证明", cata: "如为品牌代理商，须提供生产商、品牌商或商标专有权人授权销售证明文件"},
					{name: "进口货物报关单", cata: "海关出具的注有进口数量、成交总价的凭证"}
				]
			}
		},
		methods: {
			agreement () {
				this.title = "供应商入驻协议"
				this.isAgreement = true
			},
//			hangle () {
//				console.log(this.checked)
//			},
			// 入驻登录 提示
			toLogin () {
				this.tipDialog = true;
			},
			skan_q (index) {
				this.num = index;
			}
		},
        mounted () {
            var isAgreement=this.$route.query.isAgreement;
            if(isAgreement && isAgreement==1) {
                this.isAgreement = false;
            }
        }
	}
</script>

<style type="text/css" lang="less" scoped>
	.sign_wrap {
		width: 1042px;
	  min-height: 820px;
	  margin: 80px auto;
	  border: 1px solid #eee;
	  position: relative;
	  padding: 70px 50px;
	}
	.start_btn {
		position: absolute;
		top: -52px;
		right: 0;
	}
	.intro,
	.up_info {
		font-size: 14px;
		color: #333;
		p {
			line-height: 30px;
		}
	}
	.fwb {
		font-weight: bold;
	}
	.q_and_a {
		list-style: none;
	}
	.q_and_a .questions {
		  line-height: 22px;
	}
	.questions:hover {
		 cursor: pointer;
		 color: #4db7eb;
		text-decoration:underline;
	}
	.tab {
		/*display: none;*/
		margin-top: 20px;
		border: 1px dotted #c4c4c4;
		text-align: center;
		padding: 10px;
	}
	.text_intro {
		text-indent: 2em;
	}
	.actives {
		color: #4db7eb;
		text-decoration: underline;
	}
</style>


// WEBPACK FOOTER //
// intro.vue?8008af58